var React = require('react');
var Router = require('react-router');
var GameStrip = require('./game-strip/index.jsx');
var Link = require('react-router').Link;
var LeagueList = require('../common/Leaguelist.jsx');
var DateSlider = require('../common/DateSlider.jsx');
var moment = require('moment');
var RHS = require('../common/rhs/Index.jsx');
var DateFormatMixin = require('../../mixins/DateFormatMixin');

var ScoreBoard = React.createClass({
    getInitialState: function(){
        return {
            date: new Date().setHours(0,0,0,0),
            dropdownTriggered: false,
            activeDates : {}
        };
    },

    mixins: [DateFormatMixin, Router.Navigation],

    componentWillMount: function(){
        this.setState(this.getDateParams());
    },

    componentWillReceiveProps: function(){
        this.setState(this.getDateParams());
    },

    getDateParams: function(){
        var dateQuery = this.context.router.getCurrentQuery().date;
        var events =  this.props.leagues && this.props.leagues[0] && this.props.leagues[0].events;
        var eventDate = events && events.length && events[0].date || null;

        if(dateQuery){
            dateQuery = [dateQuery.substr(0,4), dateQuery.substr(4,2), dateQuery.substr(6,2)].join('/');
            dateQuery = new Date(dateQuery).setHours(0,0,0,0);
        }

        return {
            activeDates: this._getActiveDates(),
            date: dateQuery || (eventDate ? moment(eventDate).utcOffset(0).startOf('day').toDate() : new Date()).setHours(0,0,0,0)
        };
    },

    onDateSelected: function(dateObject){
        var request = this.props.request;
        var leagueQuery = this.context.router.getCurrentQuery().league;
        var query = {
            date: this.dateToKey(dateObject)
        };

        if(leagueQuery || !this.props.aggregated){
            query.league = leagueQuery || request.league;
        }

        this.state.date = dateObject;

        this.transitionTo(request.page, {
            league: request.root
        }, query);
    },

    _getActiveDates: function(){
        var formattedDates = this.props.formattedDates || [];
        var activeDates = {};

        formattedDates.map(function(date, i){
            activeDates[date] = 1;
        });
        return activeDates;
    },

    getMatchLink: function(gameLinks){
        gameLinks = gameLinks || [];
        for (var i = 0, len = gameLinks.length; i < len; i++) {
            var link = gameLinks[i];
            if(link.text === "Match"){
                return link.href;
            }
        }
        return '';
    },

    render: function () {
        var leagues = this.props.leagues;
        var request = this.props.request;
        var aggregatedScores = this.props.aggregated || false;
        var leagueName = leagues && leagues[0] && leagues[0].name;
        var heading = (aggregatedScores || !leagueName ? 'Rugby' : leagueName) + ' Scores';
        var spacers = <span> | </span>;
        var noEventsString = <div className="strip-size-lg" style={{clear:'left'}}>No games on this date.</div>;
        var dateParams = this.getDateParams();
        var activeDates = dateParams.activeDates;
        var eventsList = [];
        var league = this.context.router.getCurrentQuery().league || request.league;

        if(request.sport === 'soccer' || request.sport === 'rugby'){

            /* set up league dropdown */
            var leagueProps = {
                id: 'conference-drop',
                context: this.props.context,
                root: request.root,
                page: request.page,
                sport: request.sport,
                league: aggregatedScores ? 'aggregated' : league,
                preventLeagueAction: true,
                label : aggregatedScores ? 'All Leagues' : leagueName,
                urlFormatter: (function(baseUrl, params){
                    return params.league == 1 ? baseUrl : baseUrl +'?league=' + params.league;
                }).bind(this)
            };

        }

        leagues.map(function(league, i){
            var groupedEvents = [];
            if(aggregatedScores){
                groupedEvents.push(
                    <h2 key={league.name}>{league.name}</h2>
                );
            }
            league.events.map(function(event, j){
                event.key = event.id;
                event.anchor = this.getMatchLink(event.gameLinks);
                event.league = league.name;
                event.sport = request.sport === 'football' ? 'soccer' : request.sport;
                groupedEvents.push(<GameStrip {...event} />);
            }.bind(this));

            if(groupedEvents.length){
                eventsList.push(
                    <div key={i} className="strip-size-lg" style={{clear:'left'}}>
                        {groupedEvents}
                    </div>
                );
            }
        }.bind(this));

        return (
            <div className={this.props.shell ? '' : "main-content layout-bc"}>
                <section className="col-b">
                    <div className="scoreboards" data-date-data="null" data-is-default-group="true" id="scoreboard-page">
                        <header className="automated-header">
                            <h1 style={{padding:'0px'}}>{heading}</h1>
                            <LeagueList {...leagueProps} />
                        </header>
                        <DateSlider league={league} centered="true" date={dateParams.date} callback={this.onDateSelected} activeDates={activeDates} />
                        <div className="carousel-day"><span id="sbpDate" className="date">{'Scores for ' + moment(dateParams.date).format("MMM Do, YYYY")}</span></div>
                        {eventsList.length ? eventsList : noEventsString}
                    </div>
                </section>
                <RHS modules={this.props.rhs.modules} />
            </div>
        );
    }
});

module.exports = ScoreBoard;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/Index.jsx
 **/